import { Button, Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  aeAddPurchaseOrderDocs,
  getProjectDetails,
} from '../../../actions/projectActions'
import { PROJECT_AE_ADD_PO_DOCS_RESET } from '../../../constants/projectConstants'
import { useInput } from '../../../hooks/useInput'
import FileUploadTable from '../../Form/FileUploadTable'
import MultiFilesInput from '../../Form/MultiFilesInput'
import TextInput from '../../Form/TextInput'
import Loader from '../../Loader/Loader'

const AEAddPODocs = ({ setShowAddPODocsModal }) => {
  const dispatch = useDispatch()

  const { value: files, setValue: setFiles } = useInput([])
  const { bind: bindPurchaseOrderNumber, value: purchaseOrderNumber } =
    useInput('')

  const [filesUploading, setFilesUploading] = useState([])
  const [filesError, setFilesError] = useState('')
  const [loading, setLoading] = useState(false)

  const { project } = useSelector((state) => state.projectDetails)
  const { success } = useSelector((state) => state.projectAEAddPODocs)

  useEffect(() => {
    if (success) {
      dispatch(getProjectDetails(project._id))
      dispatch({ type: PROJECT_AE_ADD_PO_DOCS_RESET })
      setShowAddPODocsModal(false)
    }
  }, [dispatch, success, project, setShowAddPODocsModal])

  const handleSubmit = () => {
    let projectClone = project

    setLoading(true)

    projectClone.purchaseOrderNumber = purchaseOrderNumber
    projectClone.purchaseOrderFiles = files

    if ((project.status = 'Quote submitted')) {
      projectClone.status = 'In progress'
    }

    dispatch(aeAddPurchaseOrderDocs(projectClone))
  }

  return (
    <>
      <h4 className="m-b-32">Upload purchase order</h4>

      <Grid className="form-container">
        <Grid xs={6} item className="m-t-16">
          <TextInput
            name="message"
            bindValue={bindPurchaseOrderNumber}
            label="Purchase order number"
          />
        </Grid>
        <Grid xs={12} item className="m-t-16">
          <MultiFilesInput
            name="documents"
            label="Purchase order files"
            filesUploading={filesUploading}
            setFiles={setFiles}
            setFilesUploading={setFilesUploading}
            contentTop={
              <>
                Drag and drop or click to add
                <strong> purchase order files</strong>
              </>
            }
            error={filesError}
            setError={setFilesError}
          />

          {(files.length > 0 || filesUploading.length > 0) && (
            <FileUploadTable
              data={files}
              setData={setFiles}
              filesUploading={filesUploading}
            />
          )}
        </Grid>
        <div className="flex flex-end m-t-60">
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setShowAddPODocsModal(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            className="m-l-24"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={!files.length || !purchaseOrderNumber || loading}
          >
            {loading ? <Loader /> : 'Mark as paid'}
          </Button>
        </div>
      </Grid>
    </>
  )
}

export default AEAddPODocs
